import { Input } from '@builder.io/sdk';

import { formFields } from 'molecules/Form/config';
import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';
import videoField from 'molecules/VideoCustom/config';

const landingPageHeroFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: moleculeHeadingFields,
    helperText: 'Headline, subcopy, and optional buttons shown in the hero.',
  },
  {
    name: 'readTime',
    type: 'number',
    helperText: 'Estimated reading time in minutes (e.g., 20). Displays as "20 min read".',
  },
  {
    name: 'fullWidthMedia',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Enable full-width media that extends edge-to-edge without max-width constraints.',
  },
  {
    name: 'mediaType',
    type: 'string',
    enum: ['image', 'video'],
    defaultValue: 'image',
    helperText: 'Choose the media to be displayed.',
  },
  imageField('image', "options.get('mediaType') === 'image'"),
  {
    name: 'video',
    type: 'object',
    subFields: videoField.inputs,
    showIf: "options.get('mediaType') === 'video'",
    helperText: 'Video settings for the hero (URL, poster, autoplay, etc.).',
  },
  {
    name: 'variation',
    type: 'string',
    enum: ['basic', 'form'],
    defaultValue: 'basic',
    helperText: 'Select "form" to add a Marketo form next to the copy.',
  },
  ...formFields("options.get('variation') === 'form'"),
  {
    name: 'secondaryCta',
    type: 'object',
    helperText: 'Optional text link below the form (e.g., "Or, take a self-guided product tour →")',
    showIf: "options.get('variation') === 'form'",
    subFields: [
      {
        name: 'text',
        type: 'string',
        helperText: 'Link text (e.g., "Or, take a self-guided product tour")',
      },
      {
        name: 'url',
        type: 'string',
        helperText: 'Link destination URL',
      },
      {
        name: 'openInNewTab',
        type: 'boolean',
        defaultValue: false,
        helperText: 'Open link in new tab',
      },
    ],
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const landingPageHeroConfig = {
  name: 'LandingPageHero',
  inputs: landingPageHeroFields,
};

export interface LandingPageHeroProps
  extends Omit<GenerateBuilder<typeof landingPageHeroFields>, 'form'>, FormFieldProps {
  readTime?: number;
}

export default landingPageHeroConfig;
